import {Component, inject, Input, OnDestroy} from '@angular/core';
import {takeUntil} from "rxjs/operators";
import {Delivery, DeliveryData} from "../../interfaces/delivery";
import {BaseService} from "../../services/base.service";
import {HttpClient} from "@angular/common/http";
import {Subject} from "rxjs";
import {Areas} from "../../interfaces/areas";
import {User} from "../../interfaces/header-data";
import {Organization} from "../../interfaces/organization";
import {HttpErrorNotifyService} from "../../services/http-error-notify.service";

@Component({
  selector: 'app-modal-orders-history-new',
  templateUrl: './modal-orders-history-new.component.html',
  styleUrls: ['./modal-orders-history-new.component.scss']
})
export class ModalOrdersHistoryNewComponent extends BaseService implements OnDestroy {
  @Input() areas: Areas[];
  @Input() delivery: Delivery[];
  @Input() user: User;
  @Input() activeOrganization: Organization;

  public isDestroyed: Subject<boolean> = new Subject();
  public nalojkaMarkup: number;
  public isModalOrdersHistoryNewShow: boolean = false;
  public isDarkBackground: boolean = false;
  public isDropship: boolean = false;
  private notify: HttpErrorNotifyService = inject(HttpErrorNotifyService);

  constructor(
    private http: HttpClient
  ) {
    super();
  }
  openModalDeliveryShow() {
    this.http.get(this.apiRoot + 'deliveries/get_deliveries')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: DeliveryData) => {
        // {success: false} без delivery_info (виняток на беку) - інакше TypeError і модалка не відкривалась
        if (!data || !data.delivery_info) {
          this.notify.show('Не вдалося завантажити умови доставки', 'Оновіть сторінку. Якщо помилка повториться - зверніться до менеджера.');
          return;
        }

        this.areas = data.areas;
        this.delivery = Object.values(data.delivery_info);
        this.nalojkaMarkup = data.nalojka_markup;

        this.isDropship = this.delivery.some(del => del.id === 8);

        this.isModalOrdersHistoryNewShow = true;
        this.isDarkBackground = true;
      });
  }

  closeModal() {
    this.isModalOrdersHistoryNewShow = false;
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
